module.exports = __webpack_public_path__ + "static/media/LEMONMILK-Medium.51cab81e.otf";